import React, { useEffect, useState } from "react";
import { Grid, TextField, InputAdornment, Box } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { UserSearchBarProps } from "./types";
import { getSearchTermFromUrl, hasSearchParamInUrl } from "@js/util/urlUtil";
import { useRouter } from "next/router";

const UserSearchBar = (props: UserSearchBarProps) => {
    const { setUserSearch } = props;
    const router = useRouter();
    const [localUserSearch, setLocalUserSearch] = useState<string>(
        router.query.search as string
    );

    // This is to detect when we are on users page and search param is deleted - say by clicking Community
    // on the sidenav - the value in the search needs to be cleared
    const location = router.asPath;
    useEffect(() => {
        if (!hasSearchParamInUrl()) {
            setLocalUserSearch("");
            setUserSearch("");
        }
    }, [location]);

    /**
     * Search handler called when a key is pressed on the search bar.
     * Only triggers a search when 'Enter' is pressed.
     * @param e - keydown event
     */
    function search(e: any) {
        if (e.key === "Enter") {
            const searchTerm: string = e.target.value;
            const previousSearchTerm = getSearchTermFromUrl();
            if (searchTerm != previousSearchTerm) {
                if (!searchTerm) router.push(`/users`);
                else router.push(`/users?search=${searchTerm}`);

                setUserSearch(searchTerm);
            }
        }
    }

    /**
     * Set the search value
     * @param e - value of the changing field
     */
    function change(e: any) {
        setLocalUserSearch(e.target.value);
    }

    return (
        <Grid item md={7} lg={8} xl={8}>
            <Box
            //JN:  Turn the below code into a prop so that we can use this component in different ways elsewhere in the app?
            // sx={{
            //     ml: "auto",
            //     width: "263px",
            // }}
            >
                <TextField
                    onChange={change}
                    onKeyDown={search}
                    value={localUserSearch || ""}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon fontSize="small" />
                            </InputAdornment>
                        ),
                    }}
                    margin="none"
                    size="small"
                    placeholder="Search by alias or address"
                    fullWidth
                />
            </Box>
        </Grid>
    );
};

export default UserSearchBar;
